import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.activeIndex = 0
    this.paused = false
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    this.pause = this.pause.bind(this)
    this.resume = this.resume.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)

    this.render()
    this.element.addEventListener("mouseenter", this.pause)
    this.element.addEventListener("mouseleave", this.resume)
    this.element.addEventListener("focusin", this.pause)
    this.element.addEventListener("focusout", this.resume)
    this.element.addEventListener("keydown", this.handleKeydown)

    if (!this.reducedMotion && this.itemTargets.length > 4) {
      this.timer = window.setInterval(() => {
        if (!this.paused) this.advance()
      }, 4200)
    }
  }

  disconnect() {
    window.clearInterval(this.timer)
    this.element.removeEventListener("mouseenter", this.pause)
    this.element.removeEventListener("mouseleave", this.resume)
    this.element.removeEventListener("focusin", this.pause)
    this.element.removeEventListener("focusout", this.resume)
    this.element.removeEventListener("keydown", this.handleKeydown)
  }

  advance() {
    this.activeIndex = (this.activeIndex + 1) % this.itemTargets.length
    this.render()
  }

  pause() {
    this.paused = true
  }

  resume(event) {
    if (event?.relatedTarget && this.element.contains(event.relatedTarget)) return
    this.paused = false
  }

  handleKeydown(event) {
    if (event.key !== "ArrowRight" && event.key !== "ArrowDown") return

    event.preventDefault()
    this.advance()
  }

  render() {
    const itemCount = this.itemTargets.length

    this.itemTargets.forEach((item, index) => {
      const distance = (index - this.activeIndex + itemCount) % itemCount
      const isVisible = this.reducedMotion ? distance < 4 : distance === itemCount - 1 || distance < 3
      const isActive = distance === 0 || distance === 1
      const slot = distance === itemCount - 1 ? 0 : distance + 1

      item.classList.toggle("is-visible", isVisible)
      item.classList.toggle("is-active", isActive)
      item.classList.toggle("is-faded", isVisible && !isActive)
      item.style.order = isVisible ? slot : 0
      item.setAttribute("aria-hidden", isActive ? "false" : "true")
    })
  }
}
